export default __webpack_public_path__ + "static/media/scroll_top.8ecd4250.svg";